<template></template>

<script>
export default {
  name: "search"
};
</script>

<style scoped>
</style>